const controlsHelper={
    getPivotPointForControl: (controlName, data) => {
        const halfWidth = data.width / 2;
        const halfHeight = data.height / 2;
        switch (controlName) {
            case 'topLeft':
                return { x: data.x + halfWidth, y: data.y + halfHeight };
            case 'topRight':
                return { x: data.x - halfWidth, y: data.y + halfHeight };
            case 'bottomLeft':
                return { x: data.x + halfWidth, y: data.y - halfHeight };
            case 'bottomRight':
                return { x: data.x - halfWidth, y: data.y - halfHeight };
            case 'middleLeft':
                return { x: data.x + halfWidth, y: data.y };
            case 'middleRight':
                return { x: data.x - halfWidth, y: data.y };
            case 'rotate':
                return { x: data.x, y: data.y };
            default:
                return { x: data.x, y: data.y };
        }
    },
    // Helper to compute distance between two points.
    getDistance: (p1, p2) => {
        const dx = p2.x - p1.x;
        const dy = p2.y - p1.y;
        return Math.sqrt(dx * dx + dy * dy);
    },
    // getControlAtPosition:(pos, controls) => {

    //     for (const [name, control] of Object.entries(controls)) {
    //         if (!control.parent) continue;
    //         if (control.getBounds().contains(pos.x, pos.y)) {
    //             return name;
    //         }
    //     }
    //     return null;
    // },
    // isControlActive:(globalPos, controls) => {
    //     return Object.values(controls).some(control => control.getBounds().contains(globalPos.x, globalPos.y));
    // },
    getControlAtPosition: (pos, controls) => {
        for (const [name, control] of Object.entries(controls)) {
          if (!control || !control.getBounds || !control.parent) continue;
          if (control.getBounds().contains(pos.x, pos.y)) {
            return name;
          }
        }
        return null;
      },
    isControlActive: (globalPos, controls) => {
        return Object.values(controls).some(control => {
          if (!control || !control.getBounds) return false;
          return control.getBounds().contains(globalPos.x, globalPos.y);
        });
      },
      
    getCornerCursor:(controlName, rotation) => {
        const quadrant = Math.floor((rotation * (180 / Math.PI) % 360) / 90) % 4;
        const isOddQuadrant = quadrant % 2 === 1;

        if (controlName === 'topLeft' || controlName === 'bottomRight') {
            return isOddQuadrant ? 'nesw-resize' : 'nwse-resize';
        } else { // topRight or bottomLeft
            return isOddQuadrant ? 'nwse-resize' : 'nesw-resize';
        }
    },
    getMiddleCursor: (rotation) => {
        const quadrant = Math.floor((rotation * (180 / Math.PI) % 360) / 90) % 4;
        return quadrant % 2 === 0 ? 'ew-resize' : 'ns-resize';
    }
}
export default controlsHelper
